import recipeListMapping from "../components/recipeListMapping";

const recipesMapping = (data, pageType) => {
  return recipeListMapping(data.data, pageType);
};

export default recipesMapping;
